module.exports = __webpack_public_path__ + "static/media/cycle-icon4.d983aff7.svg";